import React from "react";
import filter from "../../assests/images/filter.svg";

export default function FilterMenuAudit({ handleFilterChange, filters }) {
  return (
    <div className="dropdown">
      <button
        className="btn form-label filter-box"
        type="button"
        id="filter"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
        aria-expanded="false"
      >
        <img src={filter} alt="" />
        <span style={{ paddingLeft: "8px" }}>Filter</span>
      </button>

      <ul
        className="dropdown-menu p-3"
        aria-labelledby="filter"
        id="AppDropDownId"
        style={{ minWidth: "13rem" }}
      >
        <li className="sub-step-link">Add Filters</li>
        <li>
          <div className="accordion" id="filterCreatedDate">
            <div className="border-0" style={{ padding: "10px 0 0 0" }}>
              <button
                className="accordion-button collapsed no-focus-outline"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseUpload"
                aria-expanded="false"
                aria-controls="collapseUpload"
                style={{ padding: "0px 0 10px 0" }}
              >
                <span className="review-text menu-options">Timestamp</span>
              </button>

              <div
                id="collapseUpload"
                className="accordion-collapse collapse sub-text px-2"
                data-bs-parent="#filterUpload"
              >
                <div>
                  <label>Start Date</label>
                  <input
                    className="form-control"
                    type="date"
                    name="startDate"
                    max={new Date().toISOString().split("T")[0]}
                    value={filters.startDate || ""}
                    onChange={(e) =>
                      handleFilterChange("startDate", e.target.value)
                    }
                  />
                </div>
                <div>
                  <label>End Date</label>
                  <input
                    className="form-control"
                    type="date"
                    name="endDate"
                    min={filters.startDate || null}
                    max={new Date().toISOString().split("T")[0]}
                    value={filters.endDate || ""}
                    onChange={(e) =>
                      handleFilterChange("endDate", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
}
